// client/src/deskRoutes.js — screens added for Brokerage Desk parity (docs/desk-parity.md).
import React from 'react';
import { Route } from 'react-router-dom';
import DeskSettingsPage from './pages/secure/DeskSettingsPage';
import DeskDraftsPage from './pages/secure/DeskDraftsPage';
import DeskReviewPage from './pages/secure/DeskReviewPage';
import AuditLogPage from './pages/secure/AuditLogPage';
import TcTemplatesPage from './pages/secure/TcTemplatesPage';
import MyTcItemsPage from './pages/secure/MyTcItemsPage';

/** Under /dashboard (staff login). */
export const deskDashboardRoutes = () => [
    <Route key="desk-settings" path="desk-settings" element={<DeskSettingsPage />} />,
    <Route key="desk-drafts" path="desk-drafts" element={<DeskDraftsPage />} />,
    <Route key="desk-review" path="desk-review" element={<DeskReviewPage />} />,
    <Route key="audit-log" path="audit-log" element={<AuditLogPage />} />,
    // Transaction-coordinator checklists (routes/tcChecklists.js).
    <Route key="tc-templates" path="tc-templates" element={<TcTemplatesPage />} />,
    <Route key="my-tc-items" path="my-tc-items" element={<MyTcItemsPage />} />,
];
